<template>
  <footer
    class="p-8 max-md:p-4 max-md:py-6 sm:px-20 border border-primary border-t border-l-0 border-r-0 border-b-0"
  >
    <div
      class="container mx-auto flex flex-wrap items-center justify-center md:justify-between"
    >
      <div
        class="flex flex-row sm:flex-col w-full sm:w-fit justify-between pb-8 sm:pb-0"
      >
        <a href="https://youtilpromo.ro/" class="youtil-logo" aria-describedby="desc">
          <img :src="logo" alt="Youtil Promo Logo">
        </a>
        <div id="desc" style="display:none">Youtil Promo Logo</div>
        <hr class="my-4 max-md:hidden">
        <a href="https://justsnap.de/" class="flex justify-center items-center gap-x-2">
          <span class="font-semibold">Powered by</span>
          <img :src="poweredBySrc" class="w-11 h-11" alt="Powered by Justsnap">
        </a>
      </div>
      <hr class="md:hidden border border-[#E2E2E2] w-screen -m-4 mt-4 mb-8">
      <div
        class="flex flex-wrap w-full justify-start gap-x-10 sm:w-1/4 sm:justify-between sm:gap-x-0 self-start"
      >
        <div class="w-full text-xl mb-3"><strong>Branduri</strong></div>
        <div class="text-gray-800 text-md">
          <a
            v-for="(brand, index) in brandsCol1"
            :key="index"
            :href="brand.url"
            :target="brand.target || '_blank'"
            class="block mb-2 hover:underline hover:text-primary"
          >
            {{ brand.text }}
          </a>
        </div>
        <div class="text-gray-800 text-md">
          <a
            v-for="(brand, index) in brandsCol2"
            :key="index"
            :href="brand.url"
            :target="brand.target || '_blank'"
            class="block mb-2 hover:underline hover:text-primary"
          >
            {{ brand.text }}
          </a>
        </div>
      </div>
      <div class="flex flex-wrap w-full sm:w-fit self-start">
        <div class="w-full text-xl mb-3"><strong>Suport</strong></div>
        <div class="text-gray-800 text-md">
          <a
            v-for="(sup, index) in support"
            :key="index"
            :href="sup.url"
            :target="sup.target || '_blank'"
            class="block mb-2 hover:underline hover:text-primary"
          >
            {{ sup.text }}
          </a>
        </div>
      </div>
      <div class="mt-4 md:mt-0 w-fit max-md:w-full">
        <a href="https://www.facebook.com/youtil.romania/" target="_blank">
          <img class="h-10 w-10" src="@/assets/images/fb-logo.png" alt="Youtil Romania Facebook" />
        </a>
        <span
          class="text-gray-800 text-sm block mt-2"
        >
          Suport clienți:<br><a href="mailto:suport@youtilpromo.ro" class="text-lg font-semibold hover:underline hover:text-primary">suport@youtilpromo.ro</a>
        </span>
        <div class="sal flex flex-col justify-center gap-y-5 items-center place-items-stretch">
          <a class="w-full" href="https://anpc.ro/ce-este-sal/" target="_blank">
            <img :src="salIcon" alt="Soluționarea Alternativă a Litigiilor (SAL)">
          </a>
          <a class="w-full" href="http://ec.europa.eu/consumers/odr" target="_blank">
            <img :src="solIcon" alt="Soluționarea online a litigiilor">
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import poweredBySrc from '@/assets/images/js-logo.png'
import logo from '@/assets/footer/logo.svg'
import salIcon from '@/assets/footer/sal-icon.png'
import solIcon from '@/assets/footer/sol-icon.png'

const brands = [
  { url: 'https://www.youtil.ro/brand/always/', text: 'Always' },
  { url: 'https://www.youtil.ro/brand/ariel/', text: 'Ariel' },
  { url: 'https://www.youtil.ro/brand/discreet/', text: 'Discreet' },
  { url: 'https://www.youtil.ro/brand/fairy/', text: 'Fairy' },
  { url: 'https://www.youtil.ro/brand/gillette/', text: 'Gillette' },
  {
    url: 'https://www.youtil.ro/brand/head-si-shoulders/',
    text: 'Head&Shoulders'
  },
  { url: 'https://www.youtil.ro/brand/lenor/', text: 'Lenor' },
  {
    url: 'https://www.youtil.ro/brand/lenor-detergent/',
    text: 'Lenor Detergent'
  },
  { url: 'https://www.youtil.ro/brand/mr-proper/', text: 'Mr. Proper' },
  { url: 'https://www.youtil.ro/brand/old-spice/', text: 'Old Spice' },
  { url: 'https://www.youtil.ro/brand/oral-b/', text: 'Oral-B' },
  { url: 'https://www.pampers.ro/', text: 'Pampers' },
  { url: 'https://www.youtil.ro/brand/pantene/', text: 'Pantene' }
]

const brandsCol1 = computed(() => {
  const halfIndex = Math.ceil(brands.length / 2)
  return brands.slice(0, halfIndex)
})

const brandsCol2 = computed(() => {
  const halfIndex = Math.ceil(brands.length / 2)
  return brands.slice(halfIndex)
})

const support = [
  {
    url: 'https://www.youtil.ro/despre-youtil',
    text: 'Despre YOUTIL.ro'
  },
  {
    url: 'http://www.pg.com/ro_RO/terms_conditions/index.shtml#use',
    text: 'Termeni și condiții'
  },
  {
    url: 'https://www.pg.com/privacy/romanian/privacy_statement.shtml',
    text: 'Confidenţialitate'
  },
  { url: 'https://anpc.ro/', text: 'ANPC' },
  {
    url: 'https://pgconsumersupport.secure.force.com/CarehubStandalone?Country=ro&Language=ro&Brand=P%26G&autoModal=false#brandListDiv',
    text: 'Contactează-ne'
  },
  { url: 'https://preferencecenter.pg.com/ro-ro/', text: 'Datele Mele' }
]

</script>

<style scoped lang="scss">
.footer-logo {
  max-width: 138px;
  height: auto;
  
  &::after {
    content: '';
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    height: 1px;
    width: 80%;
    background-color: #e2e2e2;
  }
}

.youtil-logo {
  max-width: 138px;
  height: auto;
}

.sal {
  margin-top: 20px;
  img {
    width: 100%;
  }
}
</style>
